var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoslogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1552,
    height: 411,
    viewBox: "0 0 1552 411",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1552,
    height: 411
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-187.59 -223.851)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(576.824 289.974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.953,490.456l40.959-39.028c18.548,20.865,37.867,32.458,65.3,32.458,22.417,0,38.252-12.749,38.252-32.843v-.776c0-22.026-19.7-34.39-52.932-34.39H349.807l-9.277-37.861,64.526-64.923H298.8v-51H481.566v44.822l-68.388,65.3c36.706,6.185,72.642,25.5,72.642,75.734v.77c0,51.007-37.1,88.489-97.375,88.489C339.754,537.21,306.134,517.891,282.953,490.456Z",
    transform: "translate(-282.953 -257.454)",
    fill: "#4a89e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.426,262.093H427.917c85.005,0,143.737,58.347,143.737,134.466v.776c0,76.119-58.732,135.236-143.737,135.236H322.426Zm105.491,216.77c48.684,0,81.528-32.843,81.528-80.758v-.77c0-47.914-32.843-81.534-81.528-81.534H381.934V478.863Z",
    transform: "translate(-77.309 -257.454)",
    fill: "#4a89e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.55,402v-.77c0-76.9,60.663-139.881,144.128-139.881s143.358,62.209,143.358,139.1v.776c0,76.9-60.669,139.875-144.128,139.875S366.55,478.892,366.55,402Zm225.271,0v-.77c0-46.368-34-85.011-81.913-85.011s-81.149,37.867-81.149,84.235v.776c0,46.368,34,85.005,81.919,85.005S591.821,448.365,591.821,402Z",
    transform: "translate(152.566 -261.346)",
    fill: "#4a89e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.284,496.4l35.16-42.115c24.348,20.094,49.852,32.843,80.758,32.843,24.348,0,39.028-9.656,39.028-25.5v-.77c0-15.071-9.271-22.8-54.478-34.39-54.491-13.91-89.65-28.981-89.65-82.7V343c0-49.076,39.413-81.534,94.668-81.534,39.413,0,73.033,12.37,100.467,34.4l-30.912,44.816C566.367,324.071,542.8,314.023,520,314.023s-34.774,10.432-34.774,23.572v.77c0,17.778,11.594,23.572,58.346,35.551,54.869,14.3,85.782,34,85.782,81.142v.776c0,53.708-40.959,83.85-99.306,83.85C489.087,539.685,447.743,525.384,415.284,496.4Z",
    transform: "translate(406.458 -260.7)",
    fill: "#4a89e9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(226.545 255.851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M527.916,342.856l-36.439,21.039A115.135,115.135,0,0,0,464.6,348.339V306.293ZM350.355,363.895a115.088,115.088,0,0,1,26.876-15.555V306.293H464.6l-87.365-50.442-150.686,87v174l150.686,87h0V561.8a114.869,114.869,0,0,1-26.876-15.549L313.91,567.288l-43.679-75.66L306.669,470.6a112.69,112.69,0,0,1,0-31.049L270.23,418.515l43.679-75.659Z",
    transform: "translate(-226.545 -255.851)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.682,
    cy: 43.682,
    r: 43.682,
    transform: "translate(145.36 161.614) rotate(-7.5)",
    fill: "#4a89e9"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M8.4,0h6.51V-25.62h7.812v-5.67H.462v5.67H8.4ZM25.956,0h6.51V-20.622L41.916-7.98h.84l9.45-12.18V0h6.51V-31.29h-6.3L42.462-17.724,32.256-31.29h-6.3Z",
    transform: "translate(1439 81)",
    fill: "#4a89e9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoslogo);
export default __webpack_public_path__ + "static/media/doslogo.6c9ea3b835bc238c7ac9eb3c9092242c.svg";
export { ForwardRef as ReactComponent };